import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbAutocompleteModule } from 'src/lib/mdb5-adapted/public-api';
import { MdbSelectModule } from 'src/lib/mdb5-adapted/public-api';
import { Observable, Subscription } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { AddressModel } from 'src/app/core/models/address.model';
import { PostCodeModel } from 'src/app/core/models/postcodes.model';
import { PostcodesService } from 'src/app/core/services/postcodes.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { LmsModalFrameComponent, NumbersOnlyDirective, LMS_NoSpecialsDirective } from '@lmsSharedUI';
export type PostalType = 'HOME' | 'POSTAL';
export type AddressTypeSearch = 'strcode' | 'area' | 'suburb';

const NO_SPECIAL_CHARS_OR_DIGITS_PATTERN = /^[a-zA-Z\s]*$/;

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule,
    MdbAutocompleteModule, MdbSelectModule, LmsModalFrameComponent,
  NumbersOnlyDirective,
    LMS_NoSpecialsDirective]
})
export class AddressesComponent implements OnInit, OnDestroy {
  // @ViewChild('sameAddress',{static: true}) sameAddressCheck!: ElementRef<HTMLInputElement>;


  searchType: AddressTypeSearch = 'strcode';

  private subs = new Subscription();

  addresses: any;
  checked = false;
  disabled = false;

  isValidForm?: boolean = false;
  //addressDetailsForm!: FormGroup;
  addressDetailsForm = this.formBuilder.group({
      homeAdressLine1: ['', [Validators.required]],
      homeAdressLine2: [''],
      homeAdressSuburb: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_OR_DIGITS_PATTERN)]],
      homeAdressTown: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_OR_DIGITS_PATTERN)]],
      homeAdressAreaCode: ['', [Validators.required, Validators.pattern('[0-9][0-9]{3}')]],
      homeAdressProvince: [''],
    });
  //postalDetailsForm!: FormGroup;
   postalDetailsForm = this.formBuilder.group({
      postalAdressLine1: ['', [Validators.required]],
      postalAdressLine2: [''],
      postalAdressSuburb: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_OR_DIGITS_PATTERN)]],
      postalAdressTown: ['', [Validators.required, Validators.pattern(NO_SPECIAL_CHARS_OR_DIGITS_PATTERN)]],
      postalAdressAreaCode: ['', [Validators.required, Validators.pattern('[0-9][0-9]{3}')]],
      postalAdressProvince: [''],
      postalType: ['']
      //'poBoxNumber':[this.addressModel.poBoxNumber]
    });
  addressModel: AddressModel = {} as AddressModel;
  hasAddress: boolean;
  clientDetails: any;
  _postalType: PostalType = 'POSTAL';

  @Input() searchValue = "";
  @Input() debounceTime = 500;
  jsonaddress: PostCodeModel[] = [];
  selectedpCode = {} as PostCodeModel;
  codeslsected = false;
  homeAdressSuburb$: Observable<any[]>;
  postalCodeSuburbs$: Observable<any[]>;
  homeAddress: any;
  postalAddress: any;
  isValidFormSubmitted = true;
  // validForm : boolean;
  submitted = false;
  isReadOnly = false;
  clientStatus: string;
  constructor(
    private postcodeService: PostcodesService,
    private formBuilder: FormBuilder,
    public global_utility: AppUtilityService,
    public modalRef: MdbModalRef<AddressesComponent>
  ) { }

  get postalType() {
    return this._postalType;
  }


  ngOnInit(): void {
    this.hasAddress = this.addresses.length > 0;
    this.clientStatus = this.clientDetails.clientStatus;
    this.addressModel.isConfirmedAddressDetails = false;
    this.addressModel.sameAsAddress = false;
    this.validateAddress();
    this.editAddress();
  }

  onHomeOptionClick($event: any) {
    const newList = $event.option.value;

    const area = newList.AREA?.toLowerCase();
    const suburb = newList.SUBURB?.toLowerCase();
    const code = newList.CODE?.toLowerCase();

    this.addressModel.homeAdressAreaCode = code;
    this.addressModel.homeAdressSuburb = suburb;
    this.addressModel.homeAdressTown = area;

    if (this.addressModel.sameAsAddress) {
      this.onOptionClick($event);
    }
  }

  resetValue() {
    console.log("Value -> ", this.addressDetailsForm.value.homeAdressTown);
    this.addressDetailsForm.value.homeAdressTown = "test";
    this.addressModel.homeAdressTown = '';
  }

  onOptionClick($event: any) {
    const newList = $event.option.value;

    const area = newList.AREA.toLowerCase();
    const suburb = newList.SUBURB.toLowerCase();
    const code = newList.CODE.toLowerCase();

    this.addressModel.postalAdressAreaCode = code;
    this.addressModel.postalAdressSuburb = suburb;
    this.addressModel.postalAdressTown = area;
    //this.postalDetailsForm.controls['postalAdressSuburb'].setValue(suburb);
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  switchsearch(type: AddressTypeSearch) {
    this.searchType = type;
  }

  // JSON ADDRESS Data Filter
  private json_ADDRESS_filter(value: string): string[] {
    //const filterValue = value.toLowerCase();
    const newList: any[] = [];
    return newList.slice(1, 30);
  }

  onCodeClicked(codeItem?: any) {
    this.selectedpCode = codeItem as PostCodeModel;
    this.codeslsected = true;
  }

  onSameAddressChange() {
    this.addressModel.sameAsAddress = !this.addressModel.sameAsAddress;
    this._postalType = 'POSTAL';
  }

  close() {
    this.modalRef.close();
  }

  preventDigitsAndSpecialChars(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122) &&
        charCode !== 32) {
      event.preventDefault();
    }
  }

  preventDigitsAndSpecialCharsOnInput(event: any): void {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
    }
  }

  saveAddress() {
    this.submitted = true;
    let isValidData = true;

    if (this.addressDetailsForm.invalid) {
      isValidData = false;
      return;
    }
  //home
    //if (!this.addressModel.sameAsAddress) {
      this.homeAddress.line1 = this.addressDetailsForm.controls.homeAdressLine1.value;
      this.homeAddress.line2 = this.addressDetailsForm.controls.homeAdressLine2.value;
      this.homeAddress.suburb = this.addressDetailsForm.controls.homeAdressSuburb.value;
      this.homeAddress.town = this.addressDetailsForm.controls.homeAdressTown.value;
      this.homeAddress.code = this.addressDetailsForm.controls.homeAdressAreaCode.value;
      this.homeAddress.province = this.addressDetailsForm.controls.homeAdressProvince.value;
      console.log('this.homeAddress.this.homeAddress.province = ' + this.homeAddress.province);
      console.log('this.homeAddress.this.homeAddress.code = ' + this.homeAddress.code);

      this.addressModel.homeAdressLine1 = this.homeAddress.line1;
      this.addressModel.homeAdressLine2 = this.homeAddress.line2;
      this.addressModel.homeAdressSuburb = this.homeAddress.suburb;
      this.addressModel.homeAdressTown = this.homeAddress.town;
      this.addressModel.homeAdressProvince = this.homeAddress.province;
      this.addressModel.homeAdressAreaCode = this.homeAddress.code;
    //}
    //postal
    this.postalAddress.line1 = this.postalDetailsForm.controls.postalAdressLine1.value;
    this.postalAddress.line2 = this.postalDetailsForm.controls.postalAdressLine2.value;
    this.postalAddress.suburb = this.postalDetailsForm.controls.postalAdressSuburb.value;
    this.postalAddress.town = this.postalDetailsForm.controls.postalAdressTown.value;
    this.postalAddress.code = this.postalDetailsForm.controls.postalAdressAreaCode.value;
    this.postalAddress.province = this.postalDetailsForm.controls.postalAdressProvince.value;
    console.log('### update addrs line = ' + this.homeAddress.line1);


    this.addressModel.postalAdressLine1 = this.postalAddress.line1;
    this.addressModel.postalAdressLine2 = this.postalAddress.line2;
    this.addressModel.postalAdressSuburb = this.postalAddress.suburb;
    this.addressModel.postalAdressTown = this.postalAddress.town;
    this.addressModel.postalAdressAreaCode = this.postalAddress.code;
    this.addressModel.postalAdressProvince = this.postalAddress.province;

    if (!this.addressModel.sameAsAddress) {
      if (this.postalDetailsForm.invalid) {
        isValidData = false;
        return;
      }

      this.addressModel.postalAdressLine1 = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressLine1.value : this.postalDetailsForm.controls.postalAdressLine1.value) ?? '';
      this.addressModel.postalAdressLine2 = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressLine2.value : this.postalDetailsForm.controls.postalAdressLine2.value) ?? '';
      this.addressModel.postalAdressSuburb = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressSuburb.value : this.postalDetailsForm.controls.postalAdressSuburb.value) ?? '';
      this.addressModel.postalAdressTown = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressTown.value : this.postalDetailsForm.controls.postalAdressTown.value) ?? '';
      this.addressModel.postalAdressAreaCode = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressAreaCode.value : this.postalDetailsForm.controls.postalAdressAreaCode.value) ?? '';
      this.addressModel.postalAdressProvince = (this.addressModel.sameAsAddress ? this.addressDetailsForm.controls.homeAdressProvince.value : this.postalDetailsForm.controls.postalAdressProvince.value) ?? '';


      this._postalType = !this.addressModel.sameAsAddress ? 'POSTAL' : 'HOME';
      this.addressModel.addressType = this._postalType;

    }

       this.updateAddresses(this.addressModel);
      return this.modalRef.close(this.addressModel);
  }

  validateAddress() {
    this.hasAddress = false;
    let haspostal = false;

    this.homeAddress = {} as any;
    this.postalAddress = {} as any;

    for (const address of this.addresses) {
      if (address.addressType == 'HOME') {
        this.homeAddress = address;
        //if (this.addressModel.homeAdressProvince == '' || ) {
        if (this.homeAddress.province == '' || this.homeAddress.code == '' ) {
          this.hasAddress = false;
        } else {
          this.hasAddress = true;
        }
      }
      if (address.addressType == 'POSTAL') {
        this.postalAddress = address;
        haspostal = true;
      }
    }
    this.addressModel.sameAsAddress = (haspostal && this.postalAddress?.line1 == this.homeAddress?.line1) ?? false;
    this._postalType = !this.addressModel.sameAsAddress ? 'POSTAL' : 'HOME';
  }

  editAddress() {
    let hasPostal = false;
    if (this.postalAddress) {
      this.addressModel.postalAdressLine1 = this.postalAddress.line1 ?? '';
      this.addressModel.postalAdressLine2 = this.postalAddress.line2 ?? '';
      this.addressModel.postalAdressSuburb = this.postalAddress.suburb;
      //this.postalDetailsForm.controls['postalAdressSuburb'].setValue(this.postalAddress.suburb);

      this.addressModel.postalAdressTown = this.postalAddress.town;
      this.addressModel.postalAdressAreaCode = this.postalAddress.code;
      this.addressModel.postalAdressProvince = this.postalAddress.province;
      hasPostal = true;
    }

    if(this.homeAddress) {
      this.addressModel.homeAdressLine1 = this.homeAddress.line1;
      this.addressModel.homeAdressLine2 = this.homeAddress.line2;
      this.addressModel.homeAdressSuburb = this.homeAddress.suburb;
      //this.addressDetailsForm.controls['homeAdressSuburb'].setValue(this.homeAddress.suburb);
      this.addressModel.homeAdressTown = this.homeAddress.town;
      this.addressModel.homeAdressAreaCode = this.homeAddress.code;
      this.addressModel.homeAdressProvince = this.homeAddress.province;
      // this.addressModel.poBoxNumber = this.postalAddress.line1;
      this.addressDetailsForm.patchValue(this.addressModel, {onlySelf: true, emitEvent: true});
      this.postalDetailsForm.patchValue(this.addressModel, {onlySelf: true, emitEvent: true});
    }
    this.addressModel.sameAsAddress = (this.postalAddress?.line1 == this.homeAddress?.line1) ?? false;


    this._postalType = (!this.addressModel.sameAsAddress || !this.postalAddress?.line2) && hasPostal ? 'POSTAL' : 'HOME';
  }

  updateAddresses(addressModel: any) {
    this.homeAddress.line1 = addressModel.homeAdressLine1;
    this.homeAddress.line2 = addressModel.homeAdressLine2;
    this.homeAddress.suburb = addressModel.homeAdressSuburb;
    this.homeAddress.town = addressModel.homeAdressTown;
    this.homeAddress.code = addressModel.homeAdressAreaCode;
    this.homeAddress.province = addressModel.homeAdressProvince;

    //this.postalAddress.line1 = this.addressModel.postalType == 'POSTAL' ? '' : '' + addressModel.postalAdressLine1;
    this.postalAddress.line1 = addressModel.postalAdressLine1 ?? '';
    this.postalAddress.line2 = addressModel.postalAdressLine2;
    this.postalAddress.suburb = addressModel.postalAdressSuburb;
    this.postalAddress.town = addressModel.postalAdressTown;
    this.postalAddress.code = addressModel.postalAdressAreaCode;
    this.postalAddress.province = addressModel.postalAdressProvince;
    console.log('### update addrs line = ' + this.homeAddress.line1);
  }

  toggleCheck(event: Event) {
    const input = event.target as HTMLInputElement;
    this.addressModel.sameAsAddress = input.checked;
  }


  get validateAddressesInput() {
    return this.addressDetailsForm.controls;
  }

  get validatePostalAddressesInput() {
    return this.postalDetailsForm.controls;
  }

  confirmAddDetails() {
    this.isValidForm = true;

    if (this.addressModel.homeAdressProvince == '' || this.addressModel?.homeAdressAreaCode == null) {
      this.addressModel.isConfirmedAddressDetails = false;
      this.hasAddress = false;
      this.isReadOnly = true;
      //this.addressModel.quoteId = this.clientDetails.quoteId;
      this.global_utility.warning(
        `Please ensure that all the information needed on this page is entered`,
        'Information required',
      );

      return;
    }

    if (this.addressDetailsForm?.invalid) {
      this.isValidForm = false;
      this.global_utility.warning(
        `Please ensure that all the information needed on this page is entered`,
        'Information required',
      );
      return;
    }

    if(!this.isValidForm) {
      this.global_utility.warning(
        `Please ensure that all the information needed on this page is entered`,
        'Information required!',
      );
      return;
    }

    this.addressModel.isConfirmedAddressDetails = true;
    this.addressModel.quoteId = this.clientDetails.quoteId;
    this.modalRef.close(this.addressModel);
  }

  removeSpaces(event: any): void {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }

}
